import { FemaGoModal, TextBoxField } from 'app-ui-componentlibrary';
import { checkIfEmailIsFEMA, checkIfEmailIsValid } from 'common/utils';
import _ from 'lodash';
import React, { useState } from 'react';
import { Form, Header } from 'semantic-ui-react';

const AddNewTeamMemberModal = ({ isOpen, toggleModal, toggleManageModal, fetchUserToManage, fetchSignatureTitleInfo, emailAdr }) => {
    const [email, setEmail] = useState('');
    const [emailTouched, setEmailTouched] = useState(false);
    const [emailError, setEmailError] = useState('')

    const validateEmail = (email) => {
        if (!checkIfEmailIsValid(email)) {
            setEmailError('Please enter a valid email');
            return false;
        } else if (!checkIfEmailIsFEMA(email)) {
            setEmailError('Please enter a valid FEMA email');
            return false;
        } else if (_.toLower(email) === _.toLower(emailAdr)) {
            setEmailError('You cannot manage your own roles.');
        } else {
            setEmailError('');
            return true;
        }
    };

    const handleSubmit = async () => {
        setEmailTouched(true);
        if (validateEmail(email)) {
            fetchUserToManage(email);
            fetchSignatureTitleInfo(email);
            resetState();
            toggleModal();
            toggleManageModal();
        }
    }

    const resetState = () => {
        setEmailTouched(false);
        setEmailError('');
        setEmail('');
    }

    return (
        <FemaGoModal
            title="Add a new team member"
            open={isOpen}
            size="small"
            buttonText="Add team member"
            confirmAction={handleSubmit}
            cancelAction={() => {
                resetState();
                toggleModal();
            }}
        >
            <Form onSubmit={handleSubmit}>
                <Header as="h4">Add a new colleague to your team via email</Header>
                <TextBoxField
                    size="small"
                    label="Email"
                    name="email"
                    title="email"
                    handleChange={(e) => {
                        e.preventDefault();
                        setEmail(e.target.value);
                        validateEmail(e.target.value)
                    }}
                    handleBlur={() => setEmailTouched(true)}
                    value={email}
                    errorMessages={emailError}
                    displayError={emailTouched && emailError}
                />
            </Form>
        </FemaGoModal>
    )
}

export default AddNewTeamMemberModal;